/* eslint-disable import/no-anonymous-default-export */
import React, { Fragment, useState, useEffect, useCallback } from 'react';
import { Button, Icon, Typography, Grid, TextField, LinearProgress } from '@mui/material';
import ScoreIcon from 'global/components/ScoreIcon';
import CheckpointForm from 'global/components/CheckpointForm';
import {
  CpScoreHeaderChild,
  CpScoreHeaderChildTypo,
  LoadContainer,
  HeaderChildName,
  HeaderChildNameH3,
  ChecklistHeader,
  ChecklistHeaderCourse,
  HeaderBtn,
  HeaderCriteria,
  CSRowTop,
  CSRow,
  MoreIcon,
  ChecklistLink,
  Images,
  CSTopic,
  CSTopicEdit,
  CpScoreHidden,
  Criteria,
  Grow,
  EditSpan,
  SpacerTopGrid,
  SpacerBottomGrid,
  ChecklistImageGrid,
  RoomBtnContainer,
  RComment,
  FixedBottomNav,
  ButtonRoot,
  CHECKLIST_HEADER_BORDER_CLASS,
  CHECKLIST_HEADER_STICK_TOP_CLASS,
  PRINT_VIEW_CLASS,
  CHECKPOINT_EDIT_CLASS,
} from './ChecklistScores.styles';
import { get, size, set, sortBy, unset, last, noop } from 'global/lib/lodash';
import { getId, AUTOTAG } from '../AssessmentScore';
import { useScreen } from 'global/styles';
import useRetrieveData from 'global/hooks/useRetrieveData';
import { useIntersect } from 'global/hooks/useIntersect';
import ModalGateway from 'global/components/ModalGateway';
import { getImageSource, uppercaseFirst, getTaskStatus, cleanCopy, shouldUseSubEditView } from 'global/utils';
import { Link } from 'react-router-dom';
import { setTaskList } from 'redux/actions/view';
import { useDispatch } from 'react-redux';
import { DetailModal } from '../../task/TaskDetail';
import { CreateModal } from '../../task/CreateModal';
import { ImageList } from 'global/components/image';
import SnackAlerts from 'global/components/snack-alerts';
import { Loading } from 'global/styles';
import LibraryIcon from '@mui/icons-material/AutoStories';
import TasksComments from './tasksComments';
import { useQueue } from 'global/hooks/useQueue';
import { MoreDrop } from 'global/components/more-drop';
import { useUser } from 'global/hooks/useUser';
import { Column, Row } from 'global/components/row';
import { Button as Btn } from 'global/components/Button';
import CheckPointInfoModal from 'global/components/CheckpointInfo';
import { useTheme } from '@mui/material/styles';
import { useTaskTypes } from '../../task/task-type-utils/useTaskTypes';
import { useHashView } from '../../share/useHashView';
import { getAvailableTaskTypes, getAvailableTaskTypesForTier, getTaskTypeIdFromTask, getTaskTypeById } from '../../task/task-type-utils';
import * as moment from 'moment';
import { Text } from 'global/components/text';
import clsx from 'clsx';
import sendData from 'redux/actions/sendData';
import { deleteSubScore, modifySubScore, SubScoreLauncher, getDisplayConfigFrom } from '../AssessmentScore/SubScore/SubScoreLauncher';
import { SubScoreCollapse } from '../AssessmentScore/SubScore/SubScoreCollapse';
import SubScoreModal, { SubScoreForm } from 'global/components/SubScoreModal';
import { Media } from '../../../global/components/Media';
import { findTaskForItem, findTasksForItem } from '../AssessmentScore/utils';

export default (props) => {
  const {
    pssvChecklist,
    assessment,
    setActiveEdit,
    activeEdit,
    updateScores,
    setCurrentAnchor,
    selectItem,
    isSelected,
    assessmentTasks,
    hasSelectedItems,
    showSelectBoxes,
    userCanEdit,
    canShowScores,
    scorecard,
    userCanLink,
    searchString,
    pssvSystem,
    updateAssessmentTasks,
    isCourse,
    isTemplate,
    printView,
    hideSystemHeader,
    bordered,
    itemPasses,
  } = props;

  const [modal, setModal] = useState(false);
  const hasImage = get(pssvChecklist, 'checklist.image');
  const [isDirty, setIsDirty] = useState(false);
  const [stickyRef, stickyEntry] = useIntersect({ rootMargin: '-40px 0px -80% 0px' });

  const [alerts, setAlerts] = useState();
  const { queue: checklistScoreQueue, clearQueue, addToQueue: addToChecklistScoreQueue } = useQueue({ onUpdate: updateScores, setAlerts, system: pssvSystem });

  const calculatedScore = get(pssvChecklist, 'value');

  const loading = !!size(checklistScoreQueue);

  useEffect(() => {
    const y = get(stickyEntry, 'isIntersecting', false);
    if (y) {
      setCurrentAnchor && setCurrentAnchor(get(props, 'pssvChecklist'));
    }
  }, [stickyEntry]);

  useEffect(() => {
    clearQueue();
  }, [activeEdit]);

  const onEditPress = useCallback(
    (e) => {
      if (activeEdit) {
        // User is closing the edit mode
        setActiveEdit();
        // Site redirects user/sidebar to the Checklist they were just editing
        setCurrentAnchor(pssvChecklist, true);
      } else {
        setActiveEdit({ ...props });
        setCurrentAnchor(pssvChecklist);
      }
    },
    [pssvChecklist]
  );

  const onImageClick = useCallback((img) => {
    setModal({ index: 0 });
  }, []);

  const id = getId(pssvChecklist);
  const currentSelect = isSelected(pssvChecklist);

  const useCompareScore = get(props, 'filter.assessment_status') !== 'active';
  const useCompare = useCompareScore && get(props, 'filter.useDiff');

  const ScoreIconProps = {
    ...(!activeEdit
      ? {
          scorecard: props.scorecard,
          useBlankCheckbox: printView ? false : showSelectBoxes,
          selected: !printView && showSelectBoxes && get(currentSelect, 'fullCount'),
          indeterminate: !printView && showSelectBoxes && currentSelect,
          onClick: printView ? undefined : () => selectItem(pssvChecklist),
          useCompare,
          compare: get(pssvChecklist, 'compare', null),
          displayValue: get(pssvChecklist, 'displayValue', null),
          canClick: false,
          filter: get(props, 'filter'),
        }
      : {}),

    score: useCompareScore && !useCompare ? get(pssvChecklist, 'compare.value') : calculatedScore,
    active: useCompareScore && !useCompare ? get(pssvChecklist, 'compare') : pssvChecklist,
  };

  const hasGenObs = !get(pssvChecklist, 'children.0.checkpointId');
  const pChildren = activeEdit && !hasGenObs ? [{}, ...get(pssvChecklist, 'children', [])] : get(pssvChecklist, 'children', []);
  const isCategory = get(props, 'filter.listGroup') === 'category';
  const isLocation = get(props, 'filter.listGroup') === 'location';
  const onlyLoc = get(props, 'filter.onlyLoc', false);
  const visibleDisplayValue = useCompareScore && !useCompare ? get(pssvChecklist, 'compare.displayValue') : get(pssvChecklist, 'displayValue');
  const checklistHasTasks = get(pssvChecklist, 'children', []).some((cp) => !!findTaskForItem(cp, assessmentTasks));
  // hideSystemHeader is true when the scorecard has exactly one system and that
  // system has exactly one checklist (PFM-2601). In that case keep checkpoints
  // visible even if the checklist score is N/A — collapsing them would hide the
  // only scoring content on the page.
  const showChildren = visibleDisplayValue !== 'N/A' || checklistHasTasks || isCourse || activeEdit || searchString || hasGenObs || useCompare || hideSystemHeader;

  const renderItem = (pssvCheckpoint, i) => {
    const isObs = !pssvCheckpoint.checkpointId;
    const hasChildren = isCategory && !!size(get(pssvCheckpoint, 'subscores'));
    const showCheckpoint = onlyLoc ? pssvCheckpoint.isSubScore || hasChildren : true;

    const items = (() => {
      const subScores = [];
      const autoSubs = [];
      let autoRender;

      if (!hasChildren) {
        return { subScores, autoSubs };
      }

      get(pssvCheckpoint, 'subscores', []).map((ss) => {
        if (ss.notes == AUTOTAG) {
          autoRender = {
            ...(autoRender || {}),
            ...pssvCheckpoint,
            ...ss,
            assessmentId: '',
            subscores: null,
            isSubScore: true,
            notes: '',
            criteria: get(autoRender, 'criteria') ? `${get(autoRender, 'criteria')}; ${get(ss, 'realm.name')}` : get(ss, 'realm.name'),
            name: `✔`,
            isAgg: true,
          };
          autoSubs.push(ss);
        } else {
          subScores.push({
            pssvParentCheckpoint: pssvCheckpoint,
            ...ss,
            assessmentId: '',
            subscores: null,
            isSubScore: true,
          });
        }
      });

      // Hide the aggregated auto-pass row only when this checkpoint has
      // exactly one auto instance and no live instances — the parent row
      // is already the pass. If live instances exist, always show the
      // auto-pass row even for a single room (native ListCheckpointRow).
      const isAuto1 = !size(subScores) && size(autoSubs) === 1;
      if (isAuto1) {
        return { subScores, autoSubs, autoRender: undefined };
      }

      return { subScores, autoSubs, autoRender };
    })();

    if (isObs && i !== 0) {
      return null;
    }

    return (
      <Fragment key={isObs ? 'obs' : pssvCheckpoint.id}>
        {activeEdit ? (
          <EditScore
            {...props}
            assessment={assessment}
            scorecard={scorecard}
            queue={checklistScoreQueue}
            addToQueue={addToChecklistScoreQueue}
            pssvChecklist={pssvChecklist}
            pssvCheckpoint={pssvCheckpoint}
            isDirty={isDirty}
            setIsDirty={setIsDirty}
          />
        ) : (
          <>
            {showCheckpoint && (
              <CheckpointScore
                {...props}
                searchString={searchString}
                updateAssessmentTasks={updateAssessmentTasks}
                scorecard={scorecard}
                canShowScores={canShowScores}
                assessmentTasks={assessmentTasks}
                hasSelectedItems={hasSelectedItems}
                showSelectBoxes={showSelectBoxes}
                isSelected={isSelected}
                selectItem={selectItem}
                pssvCheckpoint={{
                  ...pssvCheckpoint,
                  isSubScore: pssvCheckpoint.isSubScore && !hasChildren,
                }}
                pssvChecklist={pssvChecklist}
                assessment={assessment}
                isDirty={isDirty}
                setIsDirty={setIsDirty}
              />
            )}
            {hasChildren && (
              <div style={{ marginLeft: 16 }}>
                {!!items.autoRender && renderItem(items.autoRender, 0)}
                {items.subScores.map((ss, i) => renderItem(ss, i + size(items.subScores)))}
              </div>
            )}
          </>
        )}
      </Fragment>
    );
  };

  const renderItems = () => {
    const subEditView = isTemplate || isCourse ? false : shouldUseSubEditView(get(scorecard, 'config'));
    let lastSub;
    if (subEditView) {
      const f = pChildren.find((c) => c.isSubScore || !!size(c.subscores));
      lastSub = get(f, 'isSubScore') ? f : get(f, 'subscores.0', f);
      if (lastSub) {
        lastSub = cleanCopy(lastSub);
        set(lastSub, '_subscore.images', []);
        set(lastSub, '_subscore.notes', '');
        set(lastSub, '_subscore.isadd', true);

        unset(lastSub, '_subscore.id');
        if (isCategory) {
          unset(lastSub, '_subscore.realm');
        } else {
          set(lastSub, '_subscore.tag', null);
        }
      } else if (isCategory) {
        lastSub = {
          ...last(get(props, 'pssvChecklist.children', [{}])),
          supersetId: get(props, 'pssvChecklist.supersetId'),
          pssvChecklist: get(props, 'pssvChecklist.checklist'),
          _subscore: {},
        };
      }
    }

    const children = subEditView && activeEdit ? (isLocation ? pChildren.filter((p) => p.checkpointId) : pChildren) : pChildren;

    return (
      <>
        {subEditView && activeEdit && isLocation && !isTemplate && (
          <Row center>
            <SubScoreLauncher {...props} preserveRealmOnClose={true} style={{ marginLeft: 16, marginBottom: 8 }} />
          </Row>
        )}
        {children.map(renderItem)}
        {subEditView && activeEdit && isLocation && !isTemplate && (
          <Row center>
            <SubScoreLauncher {...props} preserveRealmOnClose={true} style={{ marginLeft: 16, marginBottom: 8 }} />
          </Row>
        )}
      </>
    );
  };

  const HeaderComp = isCourse ? ChecklistHeaderCourse : ChecklistHeader;

  return (
    <div id={id} data-testid={`checklist-${id}`}>
      <HeaderComp
        ref={printView ? undefined : stickyRef}
        disableSticky={!!printView}
        disableGutters={true}
        className={clsx(showChildren && CHECKLIST_HEADER_BORDER_CLASS, hideSystemHeader && CHECKLIST_HEADER_STICK_TOP_CLASS)}
      >
        {!isCourse && <ScoreIcon bordered={bordered} actionable={itemPasses?.(pssvChecklist)} {...ScoreIconProps} />}
        <HeaderChildName>
          <HeaderChildNameH3 title={pssvChecklist.name}>{pssvChecklist.name}</HeaderChildNameH3>
          {get(pssvChecklist, 'criteria') && <HeaderCriteria className="weight-criteria">{get(pssvChecklist, 'criteria')}</HeaderCriteria>}
        </HeaderChildName>
        {!isCourse && !useCompare && <CpScoreHeaderChild>{get(ScoreIconProps, 'active.displayValue')}</CpScoreHeaderChild>}
        <Grow />
        {!printView && !activeEdit && !isCourse && userCanLink && (
          <ButtonRoot component={Link} to={`/library/${scorecard.editionId}/document/${get(pssvChecklist, 'checklist.classificationId', '')}`}>
            <LibraryIcon fontSize="small" color="secondary" />
          </ButtonRoot>
        )}
        {!printView && activeEdit && <PrevNext {...props} loading={loading} stickyEntry={stickyEntry} />}
        {!printView &&
          (userCanEdit || activeEdit) &&
          !props.isReview &&
          (activeEdit ? (
            <HeaderBtn color={'primary'} onClick={() => onEditPress()} data-testid="checklist-view-mode-button">
              <Icon fontSize="small">{loading ? Loading : 'close'}</Icon>
              <EditSpan>View</EditSpan>
            </HeaderBtn>
          ) : (
            <Button color={'secondary'} onClick={() => onEditPress()} data-testid="checklist-edit-mode-button">
              <Icon fontSize="small">edit</Icon>
              <EditSpan>Edit</EditSpan>
            </Button>
          ))}
      </HeaderComp>
      {showChildren && (
        <>
          <Grid
            container
            spacing={0}
            direction={'row-reverse'}
            sx={{
              justifyContent: 'space-around',
            }}
          >
            <SpacerTopGrid size={12} />
            {hasImage && (
              <ChecklistImageGrid size={{ xs: 9, md: 5 }}>
                <Media {...get(pssvChecklist, 'checklist.image', {})} sourceType={['large', 'large-url', 'largeUrl']} onClick={onImageClick} />
              </ChecklistImageGrid>
            )}
            <Grid size={{ xs: 12, md: hasImage ? 7 : 12 }} style={{ position: 'relative' }}>
              {renderItems()}
              {activeEdit && <PrevNext {...props} loading={loading} stickyEntry={stickyEntry} type={'fixed-bottom'} />}
            </Grid>
            <SpacerBottomGrid size={12} />
          </Grid>

          {!printView && (
            <ModalGateway
              open={modal}
              onClose={() => setModal(false)}
              currentIndex={get(modal, 'index')}
              images={[hasImage]
                .filter((f) => f)
                .map((x, i) => ({
                  key: i,
                  src: getImageSource(get(x, 'large')),
                  caption: get(x, 'caption'),
                }))}
            />
          )}
        </>
      )}
      {!printView && <SnackAlerts alerts={alerts} setAlerts={setAlerts} />}
    </div>
  );
};

const PrevNext = (props) => {
  const { setActiveEdit, setCurrentAnchor, pssvChecklist } = props;
  const { isMobile } = useScreen();

  const prev = get(props, 'prev');
  const next = get(props, 'next');

  const hasPrev = !!get(prev, 'id');
  const hasNext = !!get(next, 'id');
  const showFinish = !!next && !hasNext;

  const loading = props.loading || props.isUpdating;

  const prevPress = useCallback(
    (e) => {
      if (loading) {
        return;
      }
      setActiveEdit({
        ...props,
        pssvSystem: get(prev, '_system', get(props, 'pssvSystem')),
        pssvChecklist: prev,
      });
      setCurrentAnchor(prev, true);
    },
    [loading]
  );

  const nextPress = useCallback(
    (e) => {
      if (loading) {
        return;
      }
      setActiveEdit({
        ...props,
        pssvSystem: get(next, '_system', get(props, 'pssvSystem')),
        pssvChecklist: next,
      });
      setCurrentAnchor(next, true);
    },
    [loading]
  );

  const finishPress = useCallback(() => {
    if (loading) {
      return;
    }
    setActiveEdit();
    setCurrentAnchor(pssvChecklist, true);
  }, [loading, setActiveEdit, setCurrentAnchor, pssvChecklist]);

  if (props.type === 'fixed-bottom') {
    return (
      <FixedBottomNav>
        {prev && (
          <Btn icon="keyboard_arrow_up" loading={loading} onClick={prevPress} disabled={!hasPrev}>
            PREV
          </Btn>
        )}
        {showFinish ? (
          <Btn icon="check" loading={loading} onClick={finishPress} disabled={loading}>
            Finish
          </Btn>
        ) : next ? (
          <Btn icon="keyboard_arrow_down" loading={loading} disabled={!hasNext} onClick={nextPress}>
            NEXT
          </Btn>
        ) : null}
      </FixedBottomNav>
    );
  }

  return (
    <>
      {prev && (
        <ButtonRoot color={'secondary'} onClick={prevPress} disabled={!hasPrev} size={isMobile ? 'small' : undefined}>
          <Icon>{loading ? Loading : 'keyboard_arrow_up'}</Icon>
          <EditSpan>PREV</EditSpan>
        </ButtonRoot>
      )}
      {showFinish ? (
        <ButtonRoot color={'secondary'} onClick={finishPress} disabled={loading} size={isMobile ? 'small' : undefined}>
          <Icon>{loading ? Loading : 'check'}</Icon>
          <EditSpan>Finish</EditSpan>
        </ButtonRoot>
      ) : next ? (
        <ButtonRoot color={'secondary'} disabled={!hasNext} onClick={nextPress} size={isMobile ? 'small' : undefined}>
          <Icon>{loading ? Loading : 'keyboard_arrow_down'}</Icon>
          <EditSpan>NEXT</EditSpan>
        </ButtonRoot>
      ) : null}
    </>
  );
};

export const CommentContainer = (props) => {
  const { me } = useUser();

  const { pssvCheckpoint, isCheckpointEditMode } = props;

  const [loading, setLoading] = useState(false);
  const [alerts, setAlerts] = useState();
  const [comment, setComment] = useState({
    author: get(props, 'comment.authorName') || get(props, 'comment.authorEmail', ''),
    body: '',
    createdAt: undefined,
    images: null,
    meta: {},
    ...(props.comment || {}),
  });

  const COMMENT_MAX_LENGTH = 2500;
  const COMMENT_AT_LIMIT_MESSAGE = `Your comment has reached the character limit of ${COMMENT_MAX_LENGTH} characters`;
  const bodyAtLimit = size(get(comment, 'body', '') || '') >= COMMENT_MAX_LENGTH;

  const onChange = (e) => {
    const body = `${e.target.value}`.slice(0, COMMENT_MAX_LENGTH);
    setComment({ ...comment, body });
  };

  const save = async () => {
    try {
      setLoading(true);
      const { scorecardScoreId } = pssvCheckpoint;
      await sendData({
        url: '/comments',
        method: 'post',
        data: {
          data: {
            type: 'comments',
            attributes: {
              user_id: me.id,
              ...comment,
              commentable_id: `${scorecardScoreId}`,
              commentable_type: 'scorecard_score',
            },
          },
        },
      });
      props.onSave && (await props.onSave(comment));
      props.onClose();
    } catch (err) {
      setAlerts({ message: `Error saving: ${err.message}`, severity: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <RComment className={clsx(isCheckpointEditMode && CHECKPOINT_EDIT_CLASS)}>
      <Column fullWidth className="column">
        <Row fullWidth className="textRow">
          <Text type="label_medium">{moment(comment.createdAt).format('L h:mma')}</Text>
          <Text type="label_medium">{comment.author}</Text>
          <div className="indicator" />
        </Row>
        <div className="textContainer">
          {props.comment && <Text type="label_medium">{comment.body}</Text>}
          {!props.comment && (
            <TextField
              multiline
              size="small"
              minRows={4}
              variant="outlined"
              value={comment.body}
              onChange={onChange}
              error={bodyAtLimit}
              helperText={bodyAtLimit ? COMMENT_AT_LIMIT_MESSAGE : undefined}
              slotProps={{ htmlInput: { maxLength: COMMENT_MAX_LENGTH } }}
            />
          )}
        </div>
        {!props.comment && (
          <Row fullWidth className="btnRow">
            <Btn variant="text" onClick={props.onClose}>
              CANCEL
            </Btn>
            <Btn loading={loading} onClick={save}>
              SAVE
            </Btn>
          </Row>
        )}
      </Column>
      <SnackAlerts alerts={alerts} setAlerts={setAlerts} />
    </RComment>
  );
};

export const CheckpointScore = (props) => {
  const { pssvCheckpoint, pssvChecklist, updateAssessmentTasks, assessment, selectItem, isSelected, assessmentTasks, showSelectBoxes, updateScores, scorecard, printView, itemPasses } = props;
  const [tasks, setTasks] = useState();
  const [taskModal, setTaskModal] = useState({ open: false });
  const [taskCreate, setTaskCreate] = useState({ open: false });
  const [checkpointInfo, setCheckpointInfo] = useState({});
  const [showComment, setShowComment] = useState(false);
  const { data: taskTypesData } = useTaskTypes();
  const assessmentRealmTier = get(assessment, 'data.realm.tier');
  const cpAvailableTypes = getAvailableTaskTypesForTier(getAvailableTaskTypes(taskTypesData), assessmentRealmTier);
  const [subModal, setSubModal] = useState({
    open: false,
    onClose: () => {
      setSubModal((sm) => ({ ...sm, open: false }));
      updateAssessmentTasks();
    },
  });
  const q = useQueue({ onUpdate: updateScores });
  const { queue: checkpointScoreQueue, addToQueue: addToCheckpointScoreQueue } = q;

  const isSubScore = pssvCheckpoint.isSubScore;
  const initialProcessedScore = {
    isEditMode: true,
    pssvSystem: props.pssvSystem,
    pssvChecklist: isSubScore
      ? {
          ...get(pssvCheckpoint, 'pssvParentCheckpoint.checklist', {}),
          supersetId: get(pssvCheckpoint, 'pssvParentCheckpoint.supersetId', get(pssvCheckpoint, 'supersetId')),
        }
      : pssvChecklist,
    pssvCheckpoint: isSubScore ? pssvCheckpoint.pssvParentCheckpoint : pssvCheckpoint,
    ...(isSubScore && { pssvSubScore: pssvCheckpoint }),
  };
  const isAggregateSubScore = isSubScore && get(pssvCheckpoint, 'isAgg');
  const hasCriteria = get(pssvCheckpoint, 'criteria');
  const showNotes = get(props, 'showNotes', true);
  const hasNotes = get(pssvCheckpoint, 'notes');
  const hasImages = !!size(get(pssvCheckpoint, 'images'));
  const cpOpen = showNotes ? (hasNotes || hasImages ? true : false) : false;
  const dispatch = useDispatch();
  const { me } = useUser();
  // PFM-2547: hashed share-link viewers must not see actions that wouldn't work
  // under /sharehash/v1 (no task create) or expose extra UI we don't want to
  // share (checkpoint info dialog hits the normal API + leaks template detail).
  const { active: hashViewActive } = useHashView();

  const isGobs = get(pssvCheckpoint, 'depth') === 2;

  const onOpenTasks = (taskId) => {
    dispatch(setTaskList(tasks));
    setTaskModal({
      open: true,
      onClose: () => {
        setTaskModal({ open: false });
        updateAssessmentTasks();
      },
      taskId: taskId || get(tasks, '0.id'),
    });
  };

  useEffect(() => {
    if (!assessmentTasks) return;
    const hasTasks = findTasksForItem(pssvCheckpoint, assessmentTasks, false);
    if (hasTasks) {
      setTasks(hasTasks);
    }
  }, [assessmentTasks]);

  const renderTasksCount = () => {
    const allTypes = getAvailableTaskTypes(taskTypesData);
    if (size(allTypes)) {
      // Per-task entries so clicking on a specific task opens that task (PFM-2568)
      // e.g. "Action Plan (open); Issue (pending)" with each entry as its own link
      return tasks.map((t, i) => {
        const typeId = getTaskTypeIdFromTask(t);
        const taskType = getTaskTypeById(allTypes, typeId);
        const typeName = taskType ? taskType.name : 'Task';
        const { title } = getTaskStatus(t);
        const taskIsFromTargetAssessment = !((!!t.scorecardScoreId && t.scorecardScoreId === pssvCheckpoint.scorecardScoreId) || (pssvCheckpoint.isSubScore && t.subScore?.id === pssvCheckpoint.id));
        const label = `${taskIsFromTargetAssessment ? 'Target ' : ''}${typeName} (${title})`;
        return (
          <Fragment key={t.id}>
            {i > 0 && '; '}
            <ChecklistLink component={Link} style={i > 0 ? { marginLeft: 0 } : undefined} onClick={printView ? undefined : () => onOpenTasks(t.id)} to={printView ? undefined : '#'}>
              {label}
            </ChecklistLink>
          </Fragment>
        );
      });
    }
    // Fallback: group by status
    const counts = {
      open: 0,
      pending: 0,
      closed: 0,
    };
    tasks.map((t) => {
      const { title } = getTaskStatus(t);
      set(counts, title, get(counts, title, 0) + 1);
    });
    const order = ['open', 'pending', 'closed'];
    const label = order
      .filter((o) => !!get(counts, o))
      .map((o) => `${get(counts, o)} ${uppercaseFirst(o)} Task${get(counts, o) > 1 ? 's' : ''}`)
      .join(', ');
    return (
      <ChecklistLink component={Link} onClick={printView ? undefined : () => onOpenTasks()} to={printView ? undefined : '#'}>
        {label}
      </ChecklistLink>
    );
  };

  const task = get(tasks, '0');

  let score = (() => {
    if (isGobs) {
      return 'N/A';
    } else {
      return pssvCheckpoint.value;
    }
  })();

  const isCategory = get(props, 'filter.listGroup') === 'category';
  const isSubCat = isSubScore && isCategory;
  // PFM-2544: AUTOTAG (auto-pass) instances don't block task creation, so a
  // parent stays eligible after a manual fail when those are the only instances.
  const manualSubscoresCount = size((pssvCheckpoint.subscores || []).filter((ss) => get(ss, 'notes') !== AUTOTAG));
  const hasManualSubs = !isSubScore && manualSubscoresCount > 0;

  const name = (() => {
    if (isGobs) {
      return 'General Observations';
    } else {
      if (isSubScore && !isAggregateSubScore) {
        if (isSubCat) return get(pssvCheckpoint, 'realm.name', pssvCheckpoint.name);
        const checklistName = get(pssvCheckpoint, 'checklist.name');
        return checklistName ? `${checklistName}: ${get(pssvCheckpoint, 'name')}` : get(pssvCheckpoint, 'name');
      }
      return pssvCheckpoint.name;
    }
  })();

  const openTaskCreate = (p = {}) => {
    setTaskCreate({
      open: true,
      checkpoint: pssvCheckpoint,
      checklist: get(pssvCheckpoint, 'checklist', pssvChecklist),
      realmId: get(assessment, 'data.realmId'),
      realmTier: assessmentRealmTier,
      assignedTo: get(assessment, 'data.assignees', [me]),
      assessment: assessment.data,
      ...(size(cpRemainingTypes) === 1 ? { taskTypeId: get(cpRemainingTypes, '0.id') } : {}),
      // PFM-2700: already-existing task types stay in the chooser but are disabled.
      existingTaskTypeIds,
      onClose: async (created) => {
        if (created) {
          await updateAssessmentTasks();
        }
        setTaskCreate({ open: false });
      },
      ...p,
    });
  };

  // Filter out task types that already have a task for this checkpoint/score
  const existingTaskTypeIds = (tasks || [])
    .map((t) => getTaskTypeIdFromTask(t))
    .filter(Boolean)
    .map(String);
  const cpRemainingTypes = cpAvailableTypes.filter((tt) => !existingTaskTypeIds.includes(String(tt.id)));

  // Task actions stay in the menu when they can't be used. A type that already has a
  // task is left out while another type can still be created. When none remain, each
  // type stays as a disabled "Create {type}" — the label does not fall back to a
  // generic "Create Task". Hash view, templates, assessments with tasks turned off
  // (PFM-T823), and parents that already have instances omit these actions — tasks
  // for those parents are created on the instances, not the parent row.
  const taskCreateHidden = hashViewActive || isAggregateSubScore || props.isTemplate || get(assessment, 'data.meta.tasksEnabled') === false || hasManualSubs;
  const taskCreateBlocked = !get(pssvCheckpoint, 'filters.act');
  const typesForCreateMenu = size(cpRemainingTypes) > 0 ? cpRemainingTypes : cpAvailableTypes;
  const noTypesRemain = size(cpAvailableTypes) > 0 && size(cpRemainingTypes) === 0;
  const taskCreateOptions =
    size(cpAvailableTypes) > 0
      ? typesForCreateMenu.map((tt) => ({
          title: `Create ${tt.name}`,
          hide: taskCreateHidden,
          disabled: taskCreateBlocked || noTypesRemain,
          onClick: () => openTaskCreate({ taskTypeId: tt.id }),
        }))
      : [
          {
            title: 'Create Task',
            hide: taskCreateHidden,
            disabled: taskCreateBlocked || !!size(tasks),
            onClick: () => openTaskCreate(),
          },
        ];

  // Instance scores arrive as numbers or numeric strings. A value of 100 is already
  // Pass and a value of 0 is already Fail; both actions stay visible, with the
  // current result disabled. Notes (-1) leave both enabled.
  const subScoreValue = parseInt(score, 10);

  const options = [
    // Select follows the view: checkpoints in both views, and sub-scores in By Location.
    // By Category sub-scores omit it. Editability does not affect it.
    // Hash-view viewers can't enter multi-select (PFM-2547).
    { title: 'Select', hide: (isCategory && !!isSubScore) || hashViewActive || isAggregateSubScore, onClick: () => selectItem(pssvCheckpoint) },
    {
      title: 'Pass',
      hide: !isSubScore || isAggregateSubScore || !props.userCanModify,
      disabled: subScoreValue === 100,
      onClick: async () => {
        const result = await modifySubScore({ ...get(pssvCheckpoint, '_subscore', {}), score: 100 });
        await updateScores(result);
      },
    },
    {
      title: 'Fail',
      hide: !isSubScore || isAggregateSubScore || !props.userCanModify,
      disabled: subScoreValue === 0,
      onClick: async () => {
        const result = await modifySubScore({ ...get(pssvCheckpoint, '_subscore', {}), score: 0 });
        await updateScores(result);
      },
    },
    {
      title: 'Delete Instance',
      hide: !isSubScore || isAggregateSubScore || !props.userCanModify,
      onClick: async () => {
        const result = await deleteSubScore({ ...get(pssvCheckpoint, '_subscore', {}), score: 0 });
        await updateScores(result);
      },
    },
    {
      title: 'Edit Instance',
      hide: !isSubScore || isAggregateSubScore || !props.userCanModify,
      onClick: async () => {
        setSubModal((sm) => ({
          ...sm,
          open: true,
          isDialog: true,
          initialProcessedScore: initialProcessedScore,
          realm: get(pssvCheckpoint, 'realm'),
        }));
      },
    },
    ...taskCreateOptions,
    {
      title: 'Checkpoint Info',
      // General Observations are checklist-level and have no checkpoint to describe.
      hide: hashViewActive || isSubScore || isGobs,
      onClick: () =>
        setCheckpointInfo({
          open: true,
          checklist: pssvChecklist,
          pssvCheckpoint: pssvCheckpoint,
          scorecard: scorecard,
          assessment: assessment,
          onClose: () => setCheckpointInfo({ open: false }),
        }),
    },
  ].filter((f) => !f.hide);

  const comments = get(
    get(props, 'assessment.data.scorecardScores', []).find((c) => c.id == get(pssvCheckpoint, 'scorecardScoreId')),
    'comments',
    []
  );

  const useCompareScore = get(props, 'filter.assessment_status') !== 'active';
  const useCompare = useCompareScore && get(props, 'filter.useDiff');
  const compare = get(pssvCheckpoint, 'compare', null);
  const showContent = get(props, 'showContent', true);
  const showDisplayScore = get(props, 'showDisplayScore', true) && !useCompare && !isGobs;
  // PFM-2699: in non-diff compare mode the checkpoint color/icon reads from the compare node (see scoreProps below),
  // so the label must read from the same node to stay in sync. Fall back to the active node's displayValue when the
  // selected version has no score for this checkpoint, so the label is never blank.
  const compareDisplayValue = useCompareScore && !useCompare ? get(compare, 'displayValue', null) : null;
  const displayLabel = isSubScore ? (scorecard?.config?.subScoreValueLabel || []).find((v) => v.value == pssvCheckpoint.value)?.label : (compareDisplayValue ?? pssvCheckpoint.displayValue);
  const showDrop = get(props, 'showDrop', true) && !props.isReview && !props.isCourse;
  const isTargetGoal = get(props, 'filter.assessment_status') == 'targetGoal';

  if (isTargetGoal) {
    score = get(pssvCheckpoint, 'target.value');
  }

  const scoreProps =
    isSubScore || isGobs
      ? { score }
      : {
          score: useCompareScore && !useCompare ? get(compare, 'value') : score,
          compare,
          useCompare,
          active: useCompareScore && !useCompare ? compare : pssvCheckpoint,
          openTaskCreate,
          taskTypeName: size(cpRemainingTypes) === 1 ? get(cpRemainingTypes, '0.name') : null,
          // PFM-2700: let ScoreIcon suppress the "create a task for this target?" prompt
          // when every allowed type already has a task (mirrors the triple-dot condition).
          availableTaskTypeCount: size(cpAvailableTypes),
          remainingTaskTypeCount: size(cpRemainingTypes),
          // Instances own their tasks. A parent target shouldn't offer to create one.
          suppressCreateTask: hasManualSubs,
        };

  return isGobs && !hasCriteria ? null : (
    <CSTopic>
      <CSRowTop>
        <CSRow>
          {isGobs && useCompare ? (
            <div style={{ width: 8 }}></div>
          ) : (
            <ScoreIcon
              {...q}
              {...props}
              useBlankCheckbox={printView ? false : isSubScore && isCategory ? false : showSelectBoxes}
              selected={!printView && showSelectBoxes && isSelected(pssvCheckpoint)}
              onClick={printView ? undefined : () => selectItem && selectItem(pssvCheckpoint)}
              center
              isBw={false}
              disabled={isSubScore && isCategory}
              actionable={itemPasses?.(pssvCheckpoint)}
              {...scoreProps}
              {...(printView ? { openTaskCreate: undefined } : {})}
            />
          )}
          {showDisplayScore &&
            (props.expandScoreLabel ? (
              <Typography variant="body2" sx={{ mr: 1, whiteSpace: 'nowrap' }}>
                {displayLabel}
              </Typography>
            ) : (
              <CpScoreHeaderChildTypo as={Typography} variant="body2">
                {displayLabel}
              </CpScoreHeaderChildTypo>
            ))}
        </CSRow>
        <Typography variant="body2" style={{ marginTop: '2px', ...(props.expandScoreLabel ? { flex: '1 1 auto', minWidth: 0 } : {}) }}>
          <strong>{name}</strong>
          &nbsp;
          {hasCriteria}
          {props.headerAdornment}
        </Typography>
        {!printView && (
          <MoreIcon>
            {props.isReview && get(assessment, 'data.status') !== 'completed' && (
              <Button onClick={() => setShowComment(!showComment)}>
                <Icon>add_comment</Icon>
              </Button>
            )}
            {showDrop && <MoreDrop data-testid="score-more-menu-button" options={options} />}
          </MoreIcon>
        )}
      </CSRowTop>
      {showContent && (
        <>
          {cpOpen && (
            <CpScoreHidden flush={props.flushContent}>
              {!!hasNotes && <Criteria>{`Notes: ${hasNotes || ''}`}</Criteria>}
              {!!hasImages && (
                <Images className={clsx(printView && PRINT_VIEW_CLASS)}>
                  <ImageList
                    {...(printView
                      ? {
                          spaceBetween: 3,
                          showCaption: true,
                          srcOverride: { full: 'large', thumb: 'thumb' },
                        }
                      : {
                          assessment: get(assessment, 'data'),
                          onClose: (st) => (st.hasEdits ? updateScores() : noop),
                          imageSize: 100,
                          spaceBetween: 3,
                          showCaption: true,
                          notAllowed: ['tag'],
                          collectionName: 'scorecard-score-images',
                          parentId: get(pssvCheckpoint, 'scorecardScoreId'),
                          childImagesIncludedInEdit: true,
                        })}
                    images={sortBy(pssvCheckpoint.images, 'orderColumn')}
                  />
                </Images>
              )}
            </CpScoreHidden>
          )}
          {task && (
            <CSRow>
              <CpScoreHeaderChildTypo as="span" />
              <span>{renderTasksCount()}</span>
            </CSRow>
          )}

          {task && <TasksComments tasks={tasks} />}

          {!!size(comments) && comments.map((com) => <CommentContainer comment={com} />)}
          {showComment && <CommentContainer pssvCheckpoint={pssvCheckpoint} onClose={() => setShowComment(false)} onSave={props.onCommentSave} />}

          {!printView && (
            <>
              <DetailModal {...taskModal} />
              <CreateModal {...taskCreate} />
              <SubScoreModal
                {...props}
                {...subModal}
                isDirty={props.isDirty}
                setIsDirty={props.setIsDirty}
                setNeedUpdate={true}
                addToQueue={addToCheckpointScoreQueue}
                queue={checkpointScoreQueue}
                isCourse={false}
                pssvTag={initialProcessedScore}
              />
              <CheckPointInfoModal {...checkpointInfo} />
            </>
          )}
        </>
      )}
    </CSTopic>
  );
};

const urlParams = {
  // images + comments surface the same checkpoint-definition incidental data the
  // Checkpoint Info modal reveals, so the scoring Info button can reflect it (PFM-2106).
  // editMode: 1 returns editMode.owned, the comment-visibility gate the modal uses.
  include: 'scorecardOptions,images,comments',
  editMode: 1,
};

export const EditScore = (props) => {
  return <AEditScore {...props} />;
};

const AEditScore = (props) => {
  const theme = useTheme();
  const { pssvCheckpoint, pssvChecklist, assessment, addToQueue, scorecard } = props;
  const checkpointId = get(pssvCheckpoint, 'checkpointId');
  const isObs = !checkpointId;
  const [state, setState] = useState({
    isSending: false,
    formState: {},
  });

  const [params] = useState({
    useEffect: true,
    waitFor: isObs ? null : undefined,
    params: { ...urlParams, filter: { scorecard_id: scorecard.id } },
    build: ['checkpoints'],
    transformData: (d) => get(d, '0'),
  });
  const { isView1, isView2, isView3, hasSubScores, showObservationGrid } = getDisplayConfigFrom(scorecard, props);

  const checkpointdata = useRetrieveData({ url: `/checkpoints/${checkpointId}` }, params);

  useEffect(() => {
    if (isObs) {
      checkpointdata.manuallySetData(pssvCheckpoint);
    }
  }, []);

  const { isSubScore } = pssvCheckpoint;

  const onFormReady = async (obj) => {
    try {
      if (obj.submits > 1) {
        //dont submit on first ready
        setState((s) => ({ ...s, isSending: true }));
        const result = await obj.submitSubScore();
        props.updateScores(result);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setState((s) => ({ ...s, isSending: false }));
    }
  };

  let SUBS = null;
  if (size(pssvCheckpoint.subscores)) {
    if (showObservationGrid) {
      SUBS = null;
    } else {
      SUBS = (
        <div style={isView1 || isView3 ? { marginLeft: 10, borderLeft: `4px solid ${theme.palette.divider}` } : undefined}>
          {pssvCheckpoint.subscores.map((subcheck, i) => (
            <AEditScore {...props} key={`${subcheck.id}_${i}`} pssvCheckpoint={subcheck} />
          ))}
        </div>
      );
    }
  }

  const isCompareModal = get(props, 'isCompareModal', false);

  const key = 'checkpoint-form-' + (isObs ? 'obs' : pssvCheckpoint.id);

  const SCORE = isSubScore ? (
    <SubScoreForm
      {...props}
      {...state}
      pssvTag={{
        pssvChecklist: {
          ...(pssvCheckpoint.pssvParentCheckpoint.checklist || {}),
          supersetId: get(pssvCheckpoint, 'pssvParentCheckpoint.supersetId', pssvCheckpoint.supersetId),
        },
        pssvCheckpoint: pssvCheckpoint.pssvParentCheckpoint,
        pssvSubScore: pssvCheckpoint,
        isEditMode: true,
      }}
      canChangeTag={false}
      onFormReady={onFormReady}
    />
  ) : isView2 && !isObs ? null : (
    <CheckpointForm
      highlightCompare={get(props, 'pssvCheckpoint.target.value') ?? undefined}
      {...props}
      key={key}
      setNeedUpdate={props.setNeedUpdate}
      isCourse={props.isCourse}
      addToQueue={addToQueue}
      queue={props.queue}
      pssvCheckpoint={pssvCheckpoint}
      assessmentId={get(assessment, 'data.id')}
      pssvChecklist={pssvChecklist}
      checkpointdata={checkpointdata}
      loading={checkpointdata.loading}
      scorecard={scorecard}
      assessment={assessment}
      canEditInfo={isObs ? true : hasSubScores ? isView1 : undefined}
      renderObservations={
        showObservationGrid && !isCompareModal
          ? () => {
              return (
                <RoomBtnContainer>
                  {size(pssvCheckpoint.subscores) ? (
                    <SubScoreCollapse
                      {...props}
                      isDirty={props.isDirty}
                      setIsDirty={props.setIsDirty}
                      canEdit
                      pssvCheckpoint={{
                        ...pssvCheckpoint,
                      }}
                    />
                  ) : undefined}
                  {!props.isTemplate && (
                    <SubScoreLauncher
                      {...props}
                      realmDropProps={{ placeholder: 'ADD INSTANCE' }}
                      initialProcessedScore={{ pssvCheckpoint, pssvChecklist, pssvSystem: props.pssvSystem }}
                      style={{ marginLeft: 16, marginBottom: 8 }}
                      pssvCheckpoint={pssvCheckpoint}
                      activeEdit={true}
                      hasSubScores={true}
                    />
                  )}
                </RoomBtnContainer>
              );
            }
          : undefined
      }
    />
  );

  const blocked = state.isSending || (props.queue || []).find((q) => q.id === pssvCheckpoint.checkpointId);

  const renderLoader = () => {
    return <LoadContainer>{blocked && <LinearProgress />}</LoadContainer>;
  };

  return pssvCheckpoint.error ? (
    <div>{`Error: ${get(pssvCheckpoint, 'error.message')}`}</div>
  ) : (
    <CSTopicEdit key={key}>
      {renderLoader()}
      {SCORE}
      {SUBS}
    </CSTopicEdit>
  );
};
